import React from 'react'
import Footer from '../../Footer'
import bg from '../../../img/id/deer/bg.png'
import fig1 from '../../../img/id/deer/1.png'
import fig2 from '../../../img/id/deer/2.png'

import '../Proj.css'

export default class ProjPaperModel extends React.Component{
    render(){
        return(
            <div className="proj-wrapper">
                <div className='deer-title'>
                    <h1>Paper Model</h1>
                    <p>Under supervision of Prof. Huangxu Shi.</p>
                </div>
                <div className='proj-bg'>
                    <img src={bg} />
                </div>
                <div className='proj-fig1'>
                    <img src={fig1} />
                </div>
                <p className='little-title'>Modeling with Rhino7.0, realized with paper.</p>
                <div className='proj-content'>
                    <div className='proj-side2side'>
                        <p>
                            I’ve seen some paper models sold by creators, but it feels different to create one yourself. So I used Rhino 7 to make up my own low-poly animal model and unrolled the model to pieces of flat surfaces. After choosing the paper with the desired color and texture, I used the plotting cutter to cut out the paper and glued them together.
                            <br/>
                            The result is a deer paper model that can be held over as a head mask!
                        </p>
                    </div>
                    <div className='proj-side2side'>
                        <div className='proj-fig1'>
                            <img src={fig2} />
                        </div>
                    </div>
                </div>
                <Footer back={true}/>
            </div>
        )
    }
}